module.exports = __webpack_public_path__ + "img/firm_honor_pic.ff0d47fd.jpg";